import { oz } from '@weft/utils';

export const NOTIFICATION_ALERT_STATUSES = Object.freeze({
  Read: 'Read',
  Unread: 'Unread',
  Dismissed: 'Dismissed',
});

export const NotificationAlertStatusSchema = oz.nativeEnum(NOTIFICATION_ALERT_STATUSES).openapi('NotificationAlertStatus');

export type NotificationAlertStatus = oz.infer<typeof NotificationAlertStatusSchema>;